import './styles.css.js';
import { Button } from '@magnetic/button';
import { Flex } from '@magnetic/flex';
import { useClassNames } from '@magnetic/hooks';
import { Check } from '@magnetic/icons';
import { Tag } from '@magnetic/tag';
import { Text } from '@magnetic/text';
import React, { forwardRef, useContext, useCallback } from 'react';
import { useNavContext } from '../nav-context.js';
import { NavDrawerContentContext } from './content.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const RenderNavDrawerItem = /* @__PURE__ */ __name(({
  children,
  className,
  href,
  isNew,
  leadingIcon,
  onClick,
  selected,
  ...rest
}, ref) => {
  const { closeDrawer } = useNavContext();
  const { density } = useContext(NavDrawerContentContext);
  const classNames = useClassNames(
    className,
    "mds-nav-drawer-item",
    `mds-nav-drawer-item-${density}`,
    { "mds-nav-drawer-item-selected": selected }
  );
  const handleClick = useCallback(
    (ev) => {
      onClick == null ? void 0 : onClick(ev);
      closeDrawer == null ? void 0 : closeDrawer();
    },
    [onClick, closeDrawer]
  );
  return /* @__PURE__ */ React.createElement(Button, {
    as: href && "a",
    className: classNames,
    href,
    kind: "tertiary",
    onClick: handleClick,
    ref,
    ...rest
  }, /* @__PURE__ */ React.createElement(Flex, {
    align: "center",
    gap: 8
  }, leadingIcon && /* @__PURE__ */ React.createElement("div", {
    className: "mds-nav-drawer-item-icon"
  }, leadingIcon), /* @__PURE__ */ React.createElement(Text, {
    className: "line-clamp",
    weight: selected && "semi-bold"
  }, children), isNew && /* @__PURE__ */ React.createElement(Tag.Colored, {
    color: 1,
    size: "sm"
  }, "New")), selected && /* @__PURE__ */ React.createElement(Check, {
    className: "mds-nav-drawer-item-icon",
    color: "var(--control-icon-weak-active)"
  }));
}, "RenderNavDrawerItem");
const NavDrawerItem = forwardRef(RenderNavDrawerItem);
NavDrawerItem.displayName = "Nav.Drawer.Item";

export { NavDrawerItem, RenderNavDrawerItem };
//# sourceMappingURL=item.js.map
